import React, { useEffect, useState } from 'react';
import { CheckCircle2, AlertCircle, Info, X } from 'lucide-react';
import { getToasts, subscribeToasts, dismissToast } from '../lib/toast';

const STYLE = {
  info: { icon: Info, box: 'bg-slate-800 border-slate-600 text-slate-50', tint: 'text-sky-400' },
  success: { icon: CheckCircle2, box: 'bg-emerald-900 border-emerald-600 text-emerald-50', tint: 'text-emerald-300' },
  error: { icon: AlertCircle, box: 'bg-red-900 border-red-600 text-red-50', tint: 'text-red-300' },
};

/**
 * Shows the messages from lib/toast at the bottom of the screen. They never
 * take focus or block the console; click one to dismiss it.
 */
const Toaster = () => {
  const [toasts, setToasts] = useState(getToasts);
  useEffect(() => subscribeToasts(setToasts), []);

  if (toasts.length === 0) return null;
  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[60] flex flex-col gap-2 w-[min(92vw,28rem)] pointer-events-none">
      {toasts.map(({ id, message, type }) => {
        const { icon: Icon, box, tint } = STYLE[type] || STYLE.info;
        return (
          <div
            key={id}
            role={type === 'error' ? 'alert' : 'status'}
            className={`pointer-events-auto flex items-start gap-3 rounded-xl border px-4 py-3 shadow-2xl text-sm ${box}`}
          >
            <Icon className={`w-5 h-5 shrink-0 mt-0.5 ${tint}`} aria-hidden="true" />
            <span className="flex-1 leading-snug">{message}</span>
            <button onClick={() => dismissToast(id)} aria-label="Dismiss" className="shrink-0 opacity-70 hover:opacity-100">
              <X className="w-4 h-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default Toaster;
